import {
  Box,
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  Avatar,
  ModalCloseButton,
  Icon,
  Spinner,
} from "@chakra-ui/react";
import { KYDOrganizationCompact } from "@common/interfaces/KYDOrganization";
import { KYDOrganizationUser } from "@common/interfaces/KYDUser";
import { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { Auth } from "aws-amplify";
import { clearKydEventCache } from "./EventDetail/hooks/useKydEvent";

const ChangeOrganizationModal = ({
  currentUser,
  onCancel,
  onSave,
  isOpen,
  isLoading,
}: {
  currentUser: KYDOrganizationUser;
  onCancel: () => void;
  onSave: (organization_id: string) => any;
  isOpen: boolean;
  isLoading: boolean;
}) => {
  const [clickedOrganizationId, setClickedOrganizationId] = useState(null);
  return (
    <Modal
      size={"lg"}
      isOpen={isOpen}
      onClose={onCancel}
      closeOnOverlayClick={true}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>Change Organization</ModalHeader>
        <ModalBody>
          <Stack
            maxH={"300px"}
            pb={4}
            overflowY={
              currentUser.organizations.length > 5 ? "scroll" : "inherit"
            }
          >
            {currentUser.organizations.map((org) => (
              <HStack
                key={org.id}
                px={4}
                py={2}
                borderWidth={
                  org.id === currentUser.organization_id ? "2px" : "1px"
                }
                borderColor={
                  org.id === currentUser.organization_id ? "black" : "gray.200"
                }
                rounded={"lg"}
                cursor={
                  org.id === currentUser.organization_id && !isLoading
                    ? "inherit"
                    : "pointer"
                }
                onClick={() => {
                  if (!isLoading) {
                    setClickedOrganizationId(org.id);
                    onSave(org.id);
                  }
                }}
                w="100%"
                justify={"space-between"}
              >
                {org.type === "business" ? (
                  <HStack>
                    <Avatar src={org.logo_url} name={org.name} size="sm" />
                    <Text fontWeight={"bold"}>{org.name}</Text>
                  </HStack>
                ) : (
                  <Text fontWeight={"bold"}>Personal</Text>
                )}
                {clickedOrganizationId === org.id && isLoading ? (
                  <Spinner />
                ) : null}
                <Icon
                  display={
                    org.id === currentUser.organization_id ? "inherit" : "none"
                  }
                  boxSize={8}
                  color={isLoading ? "gray.500" : "green.500"}
                  as={FaCheckCircle}
                />
              </HStack>
            ))}
            <Button
              onClick={async () => {
                clearKydEventCache();
                await Auth.signOut();
                window.location.reload();
              }}
            >
              Log Out
            </Button>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ChangeOrganizationModal;
